import clone from './clone'
import wrap  from './wrap'

export {
  clone
  wrap
}
